export default "__VITE_ASSET__De$kEeEK__"